import { Service } from '../service.js';
import { env } from '../env.js';

class TelemetriaService extends Service {
    constructor() {
        super()
        this.url = env.url + 'telemetria'
    }

    async cadastrarTelemetria(path) {
        const obj = { path }
        const response = await super.post(this.url, obj);
        
        if (response.ok) {
            return response;
        } else {
            throw new Error('HTTP ' + response.status);
        }
    }
}

export const telemetriaService = new TelemetriaService();